import Vue from 'vue'
import VueI18n from 'vue-i18n'
import translate from '../translate.json'

Vue.use(VueI18n)

// function loadLocaleMessages (): LocaleMessages {
//   const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
//   const messages: LocaleMessages = {}
//   locales.keys().forEach(key => {
//     const matched = key.match(/([A-Za-z0-9-_]+)\./i)
//     if (matched && matched.length > 1) {
//       const locale = matched[1]
//       messages[locale] = locales(key)
//     }
//   })
//   return messages
// }

const reactive = {
  get lang() {
    return localStorage.getItem('lang')
  }
}

export default new VueI18n({
  locale: reactive.lang || 'ru',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ru',
  
  // messages: loadLocaleMessages()
  // messages: translateModule.messages['ru']
  messages: translate as any
})
